import React from 'react';
import './PlacementPartners.css';

const PlacementPartners = () => {
    const partners = [
        { name: 'Google', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg' },
        { name: 'Amazon', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg' },
        { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg' },
        { name: 'IBM', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg' },
        { name: 'Deloitte', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/15/Deloitte_Logo.png' },
        { name: 'Adobe', logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Adobe_Corporate_Logo.png' },
        { name: 'Meta', logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg' },
        { name: 'Byju’s', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Byju%27s_logo.svg/2560px-Byju%27s_logo.svg.png' },
        { name: 'Flipkart', logo: 'https://seeklogo.com/images/F/flipkart-logo-C9E637A758-seeklogo.com.png' },
        { name: 'Paytm', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Paytm_Logo_%28standalone%29.svg/2560px-Paytm_Logo_%28standalone%29.svg.png' },
        { name: 'Reliance Jio', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Reliance_Jio_Logo.svg/2048px-Reliance_Jio_Logo.svg.png' },
        { name: 'Cognizant', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Cognizant_logo_2022.svg/2560px-Cognizant_logo_2022.svg.png' },
        { name: 'Zoho', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/ZOHO_logo_2023.svg/2560px-ZOHO_logo_2023.svg.png' },
        { name: 'HCL', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYn1Kry5UlURXVCxLfHyz93ISINZ__XIrNGQ&s' },
        { name: 'TCS', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgdN5uaq0RMWIAydcXeyqdkm4dtErZs3sw0w&s' },
       
      ];
      

  return (
    <div className="placement-section">
      <h2 className="placement-title">Our Placement Partners</h2>
      <div className="placement-marquee">
        <div className="placement-track">
          {partners.map((partner, index) => (
            <div key={index} className="placement-logo">
              <img src={partner.logo} alt={partner.name} />
              <span>{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlacementPartners;
